module.exports = __webpack_public_path__ + "img/alipay.c69f15da.svg";